/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Account creation request
 */
export interface AccountCreationRequest {
  name: string;
  accountType: AccountCreationRequest.AccountTypeEnum;
  status?: AccountCreationRequest.StatusEnum;
  /**
   * Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  commissionRate: number;
  /**
   * Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  stableCoinCommissionRate: number;
  allowNegativeEquityWithdraw: boolean;
  referralAgentId?: number;
  allowRfq?: boolean;
  qtyLevelsTier: AccountCreationRequest.QtyLevelsTierEnum;
  businessEntity: AccountCreationRequest.BusinessEntityEnum;
  allowInterceptors?: boolean;
  /**
   * True - means \'Internal\' account.
   */
  internalAccount?: boolean;
  routePresetId?: number;
  /**
   * Users of the account sign in with google single sign-on only and have no password
   */
  ssoOnly?: boolean;
  /**
   * In Nano seconds. 500_000_000 - 60_000_000_000.
   */
  maxIocOrderLifeTimeNs?: number;
}
export namespace AccountCreationRequest {
  export const AccountTypeEnum = {
    Company: 'COMPANY',
    Individual: 'INDIVIDUAL',
    HouseLp: 'HOUSE_LP',
    ExternalLp: 'EXTERNAL_LP',
    LiquidityReceiver: 'LIQUIDITY_RECEIVER',
    LiquidityStream: 'LIQUIDITY_STREAM',
  } as const;
  export type AccountTypeEnum = (typeof AccountTypeEnum)[keyof typeof AccountTypeEnum];
  export const StatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Paused: 'PAUSED',
    Locked: 'LOCKED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
  export const QtyLevelsTierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type QtyLevelsTierEnum = (typeof QtyLevelsTierEnum)[keyof typeof QtyLevelsTierEnum];
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
